<template>
    <Toast />
    <Toast position="center" style="min-width:15vw" group="dialogtoast">
        <template #message="slotProps">
            <div class="flex flex-column">
                <div class="text-center">
                    <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
                    <h5>{{slotProps.message.detail}}</h5>
                </div>
                <div class="grid p-fluid">
                    <div class="col-12">
                        <Button class="p-button-success" label="确定" @click="dialogmsgClose" />
                    </div>
                </div>
            </div>
        </template>
    </Toast>
    <ConfirmPopup group="confirmpopup"></ConfirmPopup>
    <ConfirmDialog></ConfirmDialog>
    <div class="layout-sidebar">
        <div class="layout-menu-container">
            <div>
                <Menubar :model="items">
                </Menubar>
            </div>
            <Tree :value="nodes" @nodeSelect="onNodeSelect" @nodeExpand="onNodeExpand"
                v-model:expandedKeys="expandedKey" v-model:selectionKeys="selectedKey" selectionMode="single">
            </Tree>
        </div>
    </div>
    <div class="layout-main-container">
        <div class="layout-main">
            <div class="card">
                <h5>{{categoryName}}</h5>
                <DataTable :value="products" v-model:filters="filters1" v-model:expandedRows="expandedRows"
                    v-model:selection="selectedRow" selectionMode="multiple" :metaKeySelection="false"
                    :filters="filters1" filterDisplay="menu" dataKey="id" :globalFilterFields="['name','mpn','sku']"
                    scrollable :tableStyle="styleHeight" :scrollHeight="sHeight" responsiveLayout="scroll" :lazy="true"
                    :loading="loading" :paginator="true" :rows="pagesize" :virtualScrollerOptions="vsOptionFun()"
                    :rowsPerPageOptions="[50, 100, 200, 500]" :totalRecords="totalRecords" :first="first"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="共{totalRecords}记录 当前页{first} 到 {last}" class="p-mt-3"
                    @page="listPage($event)" @sort="onSort($event)">
                    <template #header>
                        <div class="flex justify-content-between flex-column sm:flex-row">
                            <Button type="button" icon="pi pi-filter-slash" label="清除" class="p-button-outlined mb-2"
                                @click="clearFilter1()" />
                            <span class="p-input-icon-left mb-2" style="width:25%">
                                <i class="pi pi-search" />
                                <InputText v-model="filters1['global'].value" placeholder="输入产品名称或MPN或SKU模糊查询"
                                    style="width:100%" @keyup.enter="customFilter();" />
                            </span>
                        </div>
                    </template>
                    <Column selectionMode="multiple" frozen bodyStyle="width:3em;flex:0;"
                        headerStyle="width:3em;flex:0;">
                    </Column>
                    <Column v-for="col of listcolumns" :field="col.field" :bodyStyle="col.bodyStyle"
                        :headerStyle="col.headerStyle" :showFilterOperator="col.showFilterOperator" :header="col.header"
                        :key="col.field" :showFilterMenu="col.showFilterMenu" :showFilterMatchModes="col.showFilterMenu"
                        :filterMatchModeOptions="col.filterMatchModeOptions" :sortable="col.sortable"
                        :frozen="col.frozen">
                        <template v-if="col.islink || col.oneline || col.isimage" #body="slotProps">
                            <Button v-if="col.islink" :label="slotProps.data.sampleno"
                                @click="openProduct(slotProps.data)" class="p-button-link" />
                            <label v-if="col.oneline" class="oneline"
                                v-tooltip.top="{ value: slotProps.data[col.field], disabled: false }">{{slotProps.data[col.field]}}</label>
                            <Image v-if="col.isimage" :src="getFilePatch(slotProps.data[col.field])" width="50"
                                preview />
                        </template>
                        <template #filter="{filterModel}">
                            <InputText type="text" v-model="filterModel.value" class="p-column-filter"
                                placeholder="输入筛选" />
                        </template>
                        <template #filterclear="{filterCallback}">
                            <Button type="button" label="清除" @click="filterCallback()"
                                class="p-button-secondary"></Button>
                        </template>
                        <template #filterapply="{filterCallback}">
                            <Button type="button" label="查询" @click="filterCallback();customFilter();"
                                class="p-button-success"></Button>
                        </template>
                    </Column>
                    <Column header="操作" style="width:80px">
                        <template #body="slotProps">
                            <Button v-if="slotProps.data['readonly']=='0'" label="撤回"
                                @click="revocationFlow($event,slotProps.data)" :loading="butLoading"
                                class="p-button-link" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
        <AppFooter />
    </div>
    <Dialog :header="recordsubject" id="mainDialog" class="p-dialog-maximized" @maximize="selfmaximize"
        @unmaximize="selfmaximize" @hide="dialogClose" v-model:visible="displayMaximizable" :style="{width: '70vw'}"
        :maximizable="true" :modal="true">
        <p class="p-m-0">
            <NewUniversalPage ref="universalpage" :closeButLoadingMethod="closeButLoading"
                :closeParentMehod="closeMaximizable" :currentRow="currentRow" :freshListMethod="freshList"
                :isReadOnly="readOnly" :childNewDataConfig="childNewDataConfig" :childDelDataConfig="childDelDataConfig"
                :CellEditCompleteMethod="cellEditComplete" :noLoadChild="noLoadChild" :pageJsonConfig="pageJsonConfig"
                :loadDataAfterMethod="loadDataAfter" :inputConfig="inputConfig2" :saveBeforeMethod="saveBefore" />
        </p>
        <template #footer>
            <div class="flex p-3 card">
                <Button :label="currentState" icon="pi pi-sitemap" class="p-button-raised p-button-text mr-2"
                    @click="openLeftPosition" />
                <Button :label="editHistoryButTxt" icon="pi pi-tags" class="ml-auto" @click="showEditHistory" />
                <Button label="关闭" icon="pi pi-power-off" @click="closeMaximizable" />
                <Button v-if="!readOnly" label="保存" icon="pi pi-check" @click="saveData" :loading="butLoading"
                    autofocus />
                <Button v-if="!readOnly" label="提交" icon="pi pi-check" @click="submitData" :loading="butLoading"
                    autofocus />
            </div>
        </template>
    </Dialog>
    <Dialog header="流程信息" v-model:visible="displayPosition" :style="{width: '50vw'}" :position="position"
        :maximizable="true" :modal="true">
        <FlowHistory ref="flowhistory" :flowHistoryData="flowhistoryJson" :title="recordsubject" />
        <template #footer>
            <Button label="关闭" icon="pi pi-power-off" @click="closePosition" autofocus />
        </template>
    </Dialog>
    <Dialog header="数据导出" v-model:visible="importExcelDisplay" :style="{width: '30vw'}" :maximizable="false"
        :modal="true">
        <div class="grid p-fluid mt-3">
            <div v-if="importFinish" class="field col-12 md:col-12">
                <Button label="数据处理完成,请点击下载" @click="getExcelFilePatch" class="p-button-link" />
            </div>
            <div v-if="!importFinish" class="field col-12 md:col-12">
                <ProgressBar mode="indeterminate" style="height: .5em" />
            </div>
            <div v-if="!importFinish" class="field col-12 md:col-12">
                <label>数据处理中....</label>
            </div>
        </div>
    </Dialog>
</template>
<style type="text/css">
    .oneline {
        width: 160px;
        float: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
<script>
    import {
        ref,
    } from 'vue';
    import {
        FilterMatchMode,
    } from 'primevue/api';
    import {
        useConfirm
    } from "primevue/useconfirm";
    import ConfirmPopup from 'primevue/confirmpopup';
    import ConfigService from '../../../service/ConfigService';
    import CommonJs from '../../../js/Common.js';
    import Image from 'primevue/image';
    import NewUniversalPage from '../../../components/NewUniversalPage.vue';
    import MessageTip from '../../../components/Message';
    import AppFooter from '../../../AppFooter.vue';
    import FlowHistory from '../../../components/FlowHistory.vue';
    import requests from '../../../service/newaxios';
    import * as Base64 from 'js-base64';
    export default {
        setup() {
            const confirm = useConfirm();
            const currentMenuId = '687';
            const listcolumns = ref();
            const usermoduleauth = [];
            return {
                confirm,
                currentMenuId,
                listcolumns,
                usermoduleauth
            };
        },
        data() {
            return {
                editHistoryButTxt: '显示修改痕迹',
                uploadurl: '',
                matchModes: [{
                        label: '以字符开始',
                        value: FilterMatchMode.STARTS_WITH
                    },
                    {
                        label: '以字符结束',
                        value: FilterMatchMode.ENDS_WITH
                    },
                    {
                        label: '包含字符',
                        value: FilterMatchMode.CONTAINS
                    },
                ],
                timeMatchModes: [{
                        label: '小于',
                        value: FilterMatchMode.DATE_BEFORE
                    },
                    {
                        label: '大于',
                        value: FilterMatchMode.DATE_AFTER
                    },
                ],
                numMatchModes: [{
                        label: '大于等于',
                        value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
                    },
                    {
                        label: '小于等于',
                        value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO
                    },
                ],
                displayPosition: false,
                flowhistoryJson: null,
                pageJsonConfig: {},
                productPageJson: {},
                recordsubject: '',
                foldTitle: '',
                excelFilePatch: '',
                importFinish: false,
                importExcelDisplay: false,
                readOnly: false,
                butLoading: false,
                displayMaximizable: false,
                categoryName: '',
                expandedRows: ref([]),
                position: 'bottomleft',
                filters1: {
                    'global': {
                        value: null,
                        matchMode: FilterMatchMode.CONTAINS
                    }
                },
                selectedRow: null,
                selectedProductAuthRow: null,
                expandedKey: null,
                selectedKey: {},
                currentTeeNodeId: '',
                rootFoldName: '',
                childFoldName: '',
                foldId: '',
                currentNode: null,
                childFoldParentSelect: null,
                childFoldParentNode: null,
                noLoadChild: [],
                childNewDataConfig: {
                    images: true,
                    parts: false,
                    craft: true,
                },
                childDelDataConfig: {
                    parts: true,
                    craft: true,
                },
                sHeight: '600px',
                styleHeight: '',
                minHeight: 'min-height:600px',
                totalRecords: -1,
                first: 0,
                pagesize: 50,
                flowId: '',
                startStateId: '',
                currentState: '流程信息-当前环节:打样申请',
                currentRow: {
                    bindpage: 'productsample',
                    id: '-1',
                    workflowid: '',
                    flowguid: 'productsample',
                    boxid: '',
                    stateid: '',
                    flowid: ''
                },
                products: [],
                productauth: [],
                delproductauth: [],
                loading: false,
                nodes: [],
                items: [{
                    label: '样品操作',
                    icon: 'pi pi-fw pi-users',
                    items: [{
                        label: '新建样品',
                        icon: 'pi pi-fw pi-user-plus',
                        command: () => {
                            this.createProduct();
                        }
                    }]
                }],
                productCraftDict: [],
                inputConfig2: {
                    pricefun: (allmainelements, allchildelements, v_value) => {
                        console.log(v_value);
                        this.costPricefunBlur(allmainelements, allchildelements);
                    },
                    boxnumberfun: (allmainelements, allchildelements, v_value) => {
                        console.log(v_value);
                        this.costPricefunBlur(allmainelements, allchildelements);
                    },
                    lengthfun: (allmainelements, allchildelements, v_value) => {
                        console.log(v_value);
                        this.productlengthBlur(allmainelements, allchildelements);
                    },
                    widthfun: (allmainelements, allchildelements, v_value) => {
                        console.log(v_value);
                        this.productlengthBlur(allmainelements, allchildelements);
                    },
                    heightfun: (allmainelements, allchildelements, v_value) => {
                        console.log(v_value);
                        this.productlengthBlur(allmainelements, allchildelements);
                    },
                    packingsizefun: (allmainelements, allchildelements, v_value) => {
                        console.log(v_value);
                        this.productPackingSizeBlur(allmainelements, allchildelements);
                    },
                }
            }
        },
        configService: null,
        created() {
            this.pagesize = CommonJs.GetDefaultPageSize(this);
            this.configService = new ConfigService();
            MessageTip.initMsg();
            this.init();
        },
        methods: {
            init() {
                this.configService.getproductsample(sessionStorage.getItem("appkey")).then(data => {
                    console.log(data);
                    this.listcolumns = data.list;
                    this.pageJsonConfig = data.productpage;
                    this.productPageJson = data.productpage;
                    this.loadAllUser();
                    this.initFilters1();
                    this.loadUserAuth();
                    this.loadFlowInfo();
                    CommonJs.loadDictFromCache('ProductCraft', 'dictionaryProductCraft', this.productCraftDict,
                        this.setloadDictFromCache);
                    this.loadMenuTree('-1');
                    this.sHeight = (window.innerHeight - 280) + "px";
                    this.styleHeight = 'height:' + (window.innerHeight - 300) + 'px;';
                    this.minHeight = "height:" + (window.innerHeight - 132) + "px";
                });
            },
            vsOptionFun() {
                return CommonJs.vsOptionFun(this.pagesize, this.totalRecords);
            },
            setloadDictFromCache(v_CraftDict) {
                this.productCraftDict = v_CraftDict;
            },
            initFilters1() {
                CommonJs.initFilters(this.filters1, this.listcolumns, this.setinitFilters);
            },
            setinitFilters(v_filters1) {
                this.filters1 = v_filters1;
            },
            clearFilter1() {
                this.initFilters1();
                this.loadData(1);
            },
            customFilter() {
                setTimeout(() => {
                    this.loadData(1);
                }, 10);
            },
            openLeftPosition() {
                console.log('recordsubject:' + this.recordsubject);
                this.flowhistoryJson = this.$refs.universalpage.flowhistory;
                this.displayPosition = true;
            },
            closePosition() {
                this.displayPosition = false;
            },
            loadUserAuth() {
                var listwhere = {
                    pageindex: 1,
                    pagesize: 50,
                    conditions: [{
                        name: 'parentid',
                        value: '768',
                        operation: '='
                    }]
                };
                requests.graphql_requests.post(
                    '/graphql/?appkey=' + sessionStorage.getItem("appkey"),
                    "{usermoduleauthlist(where:" + JSON.stringify(listwhere) +
                    "){appid own authtype}}"
                ).then(res => {
                    if (res.errcode == "0") {
                        var jsonData = JSON.parse(unescape(Base64.decode(res.data)));
                        this.usermoduleauth = jsonData.data.usermoduleauthlist;
                    }
                });
            },
            listPage(event) {
                var page = event.page;
                this.pagesize = event.rows;
                CommonJs.SaveDefaultPageSize(this.pagesize, this);
                var sortfield = event['sortField'];
                var sortorder = event['sortOrder'];
                if (sortfield && sortfield != '') {
                    if (sortorder == '-1') {
                        sortorder = "desc";
                    } else {
                        sortorder = "asc";
                    }
                } else {
                    sortfield = "";
                    sortorder = "";
                }
                this.loadData(page + 1, sortfield, sortorder);
            },
            onSort(event) {
                console.log('onSort...');
                console.log(event);
                var sortfield = event['sortField'];
                var sortorder = event['sortOrder'];
                if (sortorder == '-1') {
                    sortorder = "desc";
                } else {
                    sortorder = "asc";
                }
                this.loadData(1, sortfield, sortorder);
            },
            loadData(v_page, v_sortfield, v_sortorder) {
                this.loading = true;
                var listwhere = {
                    pageindex: v_page,
                    pagesize: this.pagesize,
                    conditions: [{
                        name: 'productdirectoryid',
                        value: this.currentNode.key,
                        operation: '='
                    }]
                };
                if (v_sortfield && v_sortorder) {
                    listwhere['sortfield'] = v_sortfield;
                    listwhere['sortorder'] = v_sortorder;
                }
                for (var key in this.filters1) {
                    if (key == 'global' && this.filters1[key]['value']) {
                        listwhere.conditions.push({
                            name: 'name,mpn,sku',
                            value: this.filters1[key]['value'],
                            operation: this.filters1[key]['matchMode']
                        });
                    }
                    if (this.filters1[key]['constraints']) {
                        for (var i = 0; i < this.filters1[key].constraints.length; i++) {
                            if (this.filters1[key].constraints[i].value && this.filters1[key].constraints[i].value !=
                                '') {
                                listwhere.conditions.push({
                                    name: key,
                                    value: this.filters1[key].constraints[i].value,
                                    operation: this.filters1[key].constraints[i].matchMode
                                });
                            }
                        }
                    }
                }
                requests.graphql_requests.post(
                    '/graphql/?appkey=' + sessionStorage.getItem("appkey"),
                    "{productsamplelist(where:" + JSON.stringify(listwhere) +
                    "){id creater createtime boxnumber buyer colorname  costprice  grossweight height length mpn name netweight packingnumber packingsize packingway price productdirectory size sku taxrebates unitname width imageurl factoryid sampleno orderdate finishdate factorysku quantity factoryname factorycode approvestatusname approvestatus flowid workflowid boxid stateid currentstatename readonly}}"
                ).then(res => {
                    this.loading = false;
                    if (res.errcode == "0") {
                        var jsonData = JSON.parse(unescape(Base64.decode(res.data)));
                        this.products = jsonData.data.productsamplelist;
                        this.totalRecords = jsonData.page.allrecord;
                        this.first = this.pagesize * (jsonData.page.pageindex - 1);
                    }
                });
            },
            loadMenuTree(v_parentId, v_nodes) {
                var listwhere = {
                    pageindex: 1,
                    pagesize: 50,
                    conditions: [{
                        name: 'parentid',
                        value: v_parentId,
                        operation: '='
                    }, {
                        name: 'treetype',
                        value: 'productsample',
                        operation: '='
                    }]
                };
                requests.graphql_requests.post(
                    '/graphql/?appkey=' + sessionStorage.getItem("appkey"),
                    "{usertreemenulist(where:" + JSON.stringify(listwhere) +
                    "){key label data nodetype parentid parenturl canedit candel cannew createrid icon leaf children {key label data nodetype parentid parenturl canedit candel cannew createrid icon leaf} }}"
                ).then(res => {
                    if (res.errcode == "0") {
                        var jsonData = JSON.parse(unescape(Base64.decode(res.data)));
                        if (v_parentId == "-1") {
                            this.nodes = jsonData.data.usertreemenulist;
                            if (this.nodes && this.nodes.length > 0) {
                                this.selectedKey = {};
                                this.selectedKey[this.nodes[0].key] = true;
                                this.expandedKey = {};
                                this.expandedKey[this.nodes[0].key] = true;
                                this.currentTeeNodeId = this.nodes[0].key;
                                this.categoryName = this.nodes[0].label;
                                this.currentNode = this.nodes[0];
                                this.loadData(1);
                            }
                        } else {
                            if (!v_nodes.children) v_nodes['children'] = [];
                            for (var i = 0; i < jsonData.data.usertreemenulist.length; i++) {
                                v_nodes.children.push(jsonData.data.usertreemenulist[i]);
                            }
                        }
                    }
                });
            },
            onNodeSelect(node) {
                this.items = [];
                this.selectedRow = [];
                var productObj = {
                    label: '样品操作',
                    icon: 'pi pi-fw pi-file',
                    items: [{
                        label: '新建样品',
                        icon: 'pi pi-fw pi-user-plus',
                        command: () => {
                            this.createProduct();
                        }
                    }]
                };
                this.currentNode = node;
                if (node.key == "4") {
                    productObj.items.push({
                        separator: true
                    });
                    productObj.items.push({
                        label: '删除',
                        icon: 'pi pi-fw pi-trash',
                        command: () => {
                            this.delProduct();
                        }
                    });
                }
                if (node.nodetype == "1" || node.key == "2") {
                    this.categoryName = node.label + '样品列表';
                    productObj.items.push({
                        separator: true
                    });
                    productObj.items.push({
                        label: '样品单打印',
                        icon: 'pi pi-fw pi-user-plus',
                        command: () => {
                            this.exportProduct();
                        }
                    });
                    productObj.items.push({
                        separator: true
                    });
                    productObj.items.push({
                        label: '复制',
                        icon: 'pi pi-fw pi-file',
                        command: () => {
                            this.copyProduct();
                        }
                    });
                } else {
                    this.categoryName = node.label;
                }
                this.items.push(productObj);
                this.loadData(1);
            },
            onNodeExpand(node) {
                console.log('onNodeExpand');
                console.log(node);
                if (node.nodetype == "1" && (!node.children || node.children.length == 0)) {
                    this.loadMenuTree(node.key, node);
                }
            },
            onCreateFoldNodeSelect(node) {
                console.log('onCreateFoldNodeSelect:');
                console.log(this.childFoldParentSelect);
                this.childFoldParentNode = node;
            },
            closeMaximizable() {
                this.displayMaximizable = false;
            },
            removeNodeById(v_id, v_nodes) {
                for (var i = 0; i < v_nodes.length; i++) {
                    if (v_nodes[i].key == v_id) {
                        v_nodes.splice(i, 1);
                        return true;
                    } else {
                        if (v_nodes[i]['children'] && v_nodes[i]['children'].length > 0) {
                            if (this.removeNodeById(v_id, v_nodes[i]['children'])) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            },
            copyProduct() {
                if (!CommonJs.userOwerAppId(this.usermoduleauth, 'CreateProductSample')) {
                    MessageTip.warnmsg('请联系管理员开通新建样品权限');
                    return;
                }
                if (!this.selectedRow || this.selectedRow.length == 0) {
                    MessageTip.warnmsg('请选择要复制的样品');
                    return;
                }
                if (this.selectedRow.length != 1) {
                    MessageTip.warnmsg('请选择一个要复制的样品');
                    return;
                }
                this.noLoadChild = [];
                this.pageJsonConfig = this.productPageJson;
                this.readOnly = false;
                this.recordsubject = "复制样品" + this.selectedRow[0].name;
                this.currentRow = {
                    isCopy: true,
                    bindpage: 'productsample',
                    id: this.selectedRow[0].id,
                    workflowid: '',
                    flowguid: 'productsample',
                    boxid: '',
                    stateid: this.startStateId,
                    flowid: this.flowId,
                };
                this.displayMaximizable = true;
            },
            createProduct() {
                if (!CommonJs.userOwerAppId(this.usermoduleauth, 'CreateProductSample')) {
                    MessageTip.warnmsg('请联系管理员开通新建样品权限');
                    return;
                }
                this.editHistoryButTxt = '显示修改痕迹';
                this.pageJsonConfig = this.productPageJson;
                this.readOnly = false;
                this.currentRow = {
                    bindpage: 'productsample',
                    id: '-1',
                    workflowid: '',
                    flowguid: 'productsample',
                    boxid: '',
                    stateid: this.startStateId,
                    flowid: this.flowId,
                };
                this.noLoadChild = [];
                this.recordsubject = '新增样品';
                this.displayMaximizable = true;
            },
            saveBefore(v_data) {
                console.log('saveBefore1:');
                console.log(v_data);
                return v_data;
            },
            openProduct(v_data) {
                this.editHistoryButTxt = '显示修改痕迹';
                this.noLoadChild = [];
                this.pageJsonConfig = this.productPageJson;
                if (this.currentNode.key == "4" || this.currentNode.key == "1") {
                    this.readOnly = false;
                } else {
                    this.readOnly = true;
                }
                this.currentState = '流程信息-当前环节:' + v_data.currentstatename;
                this.recordsubject = v_data.name;
                if (this.currentNode.key == "4") {
                    this.currentRow = {
                        bindpage: 'productsample',
                        id: v_data.id,
                        workflowid: v_data.workflowid,
                        flowguid: 'productsample',
                        boxid: v_data.boxid,
                        stateid: this.startStateId,
                        flowid: this.flowId,
                    };
                } else {
                    this.currentRow = {
                        bindpage: 'productsample',
                        id: v_data.id,
                        workflowid: v_data.workflowid,
                        flowguid: 'productsample',
                        boxid: v_data.boxid,
                        stateid: v_data.stateid,
                        flowid: v_data.flowid,
                    };
                }
                this.displayMaximizable = true;
            },
            delProduct() {
                if (!this.selectedRow || this.selectedRow.length == 0) {
                    MessageTip.warnmsg('请选择要删除的样品');
                    return;
                }
                var delRecord = [];
                for (var k1 = 0; k1 < this.selectedRow.length; k1++) {
                    delRecord.push({
                        "id": this.selectedRow[k1]["id"],
                    });
                }
                if (delRecord.length > 0) {
                    this.butLoading = true;
                    requests.graphql_requests.post(
                        '/graphql/?appkey=' + sessionStorage.getItem("appkey"),
                        "delete{productsamplelist(o:" + JSON.stringify(delRecord) +
                        "){id}}"
                    ).then(res => {
                        this.butLoading = false;
                        if (res.errcode == "0") {
                            this.selectedRow = null;
                            this.loadData(1);
                            MessageTip.successmsg('删除成功');
                        } else {
                            MessageTip.warnmsg('删除失败');
                        }
                    });
                }
            },
            submitData() {
                this.butLoading = true;
                this.$refs.universalpage.saveInfo();
                this.editHistoryButTxt = '显示修改痕迹';
            },
            saveData() {
                this.butLoading = true;
                this.$refs.universalpage.saveInfo(true);
                this.editHistoryButTxt = '显示修改痕迹';
            },
            freshList() {
                this.butLoading = false;
                this.loadData(1);
            },
            closeRootFold() {
                this.displayRootFold = false;
            },
            closeChildFold() {
                this.displayChildFold = false;
            },
            closeButLoading(val) {
                if (val) {
                    this.butLoading = true;
                } else {
                    this.butLoading = false;
                }
            },
            getFilePatch(v_patch) {
                if (v_patch == '') {
                    return '/calf/plat/file/attachment/10/noimg.jpg?appkey=' + sessionStorage.getItem("appkey");
                } else {
                    return '/calf/plat/file/' + v_patch + '?appkey=' + sessionStorage.getItem("appkey");
                }
            },
            formatData(v_value) {
                if (v_value) {
                    return '是';
                } else {
                    return '否';
                }
            },
            loadAllUser() {
                var dictCacheData = sessionStorage.getItem('userdict');
                if (!dictCacheData || dictCacheData && dictCacheData.length == 0) {
                    dictCacheData = sessionStorage.getItem('dictionaryuser');
                }
                if (dictCacheData && dictCacheData.length > 0) {
                    return;
                }
                var dictlistwhere = {
                    pageindex: 1,
                    pagesize: 50,
                    conditions: []
                };
                var graphql = '{userdictlist(where:' + JSON.stringify(dictlistwhere) +
                    '){name code comment}}';
                requests.graphql_requests.post(
                    '/graphql/?appkey=' + sessionStorage.getItem("appkey"),
                    graphql
                ).then(res => {
                    if (res.errcode == "0") {
                        var dataObj = JSON.parse(unescape(Base64.decode(res.data))).data;
                        console.log(dataObj);
                        var dictData = dataObj['userdictlist'];
                        sessionStorage.setItem('userdict', JSON.stringify(dictData));
                    }
                });
            },
            onCellEditComplete(event) {
                console.log('onCellEditComplete...');
                let {
                    data,
                    newValue,
                    field
                } = event;
                data[field] = newValue;
                console.log(data[field]);
            },
            cellEditComplete(tablename, field, data, rowdata, childTableFooterObj, v_childelements,
                v_alonechildelements, v_elements) {
                console.log('cellEditCompleteMethod..');
                console.log(tablename);
                console.log(field);
                console.log(data);
                console.log(rowdata);
                console.log(childTableFooterObj);
                console.log(v_childelements);
                console.log(v_alonechildelements);
                console.log(v_elements);
            },
            loadDataAfter(v_mainelements, v_childelements, v_originalData) {
                console.log(v_mainelements);
                console.log(v_childelements);
                console.log(v_originalData);
                if (this.currentRow.isCopy) {
                    for (var k3 = 0; k3 < v_mainelements.length; k3++) {
                        if (v_mainelements[k3]['name'] == 'sampleno') {
                            v_mainelements[k3]['val'] = "*****";
                        }
                        if (v_mainelements[k3]['name'] == 'buyerid') {
                            v_mainelements[k3]['val'] = sessionStorage.getItem("userid");
                        }
                    }
                }
                if (this.currentRow && this.currentRow['id'] == '-1') {
                    if (this.currentNode && this.currentNode.nodetype == "1") {
                        for (var k = 0; k < v_mainelements.length; k++) {
                            if (v_mainelements[k]['name'] == 'productdirectoryid') {
                                v_mainelements[k]['val'] = this.currentNode.key;
                                break;
                            }
                        }
                    }
                    for (var k6 = 0; k6 < this.pageJsonConfig['region_1']['left']['element'].length; k6++) {
                        var configItem = this.pageJsonConfig['region_1']['left']['element'][k6];
                        if (configItem['default'] && configItem['default'] != '') {
                            for (var k5 = 0; k5 < v_mainelements.length; k5++) {
                                if (v_mainelements[k5]['name'] == configItem['name']) {
                                    v_mainelements[k5]['val'] = configItem['default'];
                                    break;
                                }
                            }
                        }
                    }
                    for (var k2 = 0; k2 < v_childelements.length; k2++) {
                        if (v_childelements[k2]['name'] == 'images') {
                            v_childelements[k2]['rows'] = [];
                        }
                        if (v_childelements[k2]['name'] == 'craft') {
                            v_childelements[k2]['rows'] = [];
                            for (var k4 = 0; k4 < this.productCraftDict.length; k4++) {
                                v_childelements[k2]['rows'].push({
                                    id: this.getNewId(),
                                    createtime: CommonJs.GetCurrentDate(),
                                    creater: sessionStorage.getItem("username"),
                                    cname: this.productCraftDict[k4]['name'],
                                    craftdictid: this.productCraftDict[k4]['code'],
                                    craftcontent: '',
                                    parentid: ''
                                });
                            }
                        }
                    }
                }
            },
            getNewId() {
                return this.$refs.universalpage.getNewId();
            },
            loadFlowInfo() {
                requests.plat_requests.post(
                    '/calf/plat/FlowInfo?appkey=' + sessionStorage.getItem(
                        "appkey"), {
                        FlowGuid: 'productsample',
                        BoxId: '',
                    }).then(res => {
                    console.log('loadFlowInfo...');
                    console.log(res);
                    if (res.errcode == "0") {
                        var retObj = JSON.parse(unescape(Base64.decode(res.data)));
                        console.log(retObj);
                        this.flowId = retObj.FlowId;
                        this.startStateId = retObj.CurrentStateId;
                    }
                });
            },
            exportProduct() {
                if (!this.selectedRow) {
                    MessageTip.warnmsg('请选择要打印的样品');
                    return;
                }
                if (this.selectedRow.length != 1) {
                    MessageTip.warnmsg('只能选择一个样品');
                    return;
                }
                console.log('exportProduct....');
                console.log(this.selectedRow);
                var exportInput = {
                    templateId: '313591223414853',
                    appKey: sessionStorage.getItem("appkey"),
                    conditions: [{
                        schemaName: 'productsample',
                        conditionValue: [{
                            name: 'id',
                            value: this.selectedRow[0]['id'],
                            operation: '='
                        }, {
                            name: 'export',
                            value: '',
                            operation: '='
                        }],
                    }],
                };
                this.excelFilePatch = '';
                this.importFinish = false;
                this.importExcelDisplay = true;
                requests.create_plat_requests(sessionStorage.getItem("corpid"), sessionStorage.getItem("storeid")).post(
                        '/calf/plat/DecisionAnalysisExport?appkey=' + sessionStorage.getItem("appkey"), exportInput)
                    .then(
                        res => {
                            console.log(res);
                            if (res.data.errcode == "0") {
                                var retObj = JSON.parse(unescape(Base64.decode(res.data.data)));
                                console.log('exportProduct:');
                                console.log(retObj);
                                this.excelFilePatch = retObj.filepatch;
                                this.importFinish = true;
                            } else {
                                this.importExcelDisplay = false;
                                MessageTip.warnmsg(res.data);
                            }
                        });
            },
            getExcelFilePatch() {
                location.href = '/calf/plat/file/' + this.excelFilePatch + '?appkey=' + sessionStorage.getItem(
                    "appkey");
                return;
            },
            revocationFlow(event, v_data) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: '确认要撤回?',
                    group: 'confirmpopup',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.butLoading = true;
                        requests.plat_requests.post(
                            '../calf/plat/FlowRevocation?appkey=' + sessionStorage.getItem(
                                "appkey"), {
                                workflowid: v_data['workflowid'],
                                boxid: v_data['boxid'],
                                bindpage: 'productsample',
                            }
                        ).then(res => {
                            if (res.errcode == "0") {
                                this.butLoading = false;
                                this.loadData(1);
                                MessageTip.successmsg('撤回成功');
                            } else {
                                this.butLoading = false;
                            }
                        });
                    },
                    reject: () => {}
                });
            },
            productPackingSizeBlur(allmainelements, allchildelements) {
                console.log('productPackingSizeBlur...');
                console.log(allmainelements);
                console.log(allchildelements);
                var packingsize = '';
                for (var k6 = 0; k6 < allmainelements.length; k6++) {
                    if (allmainelements[k6]['name'] == 'packingsize') {
                        packingsize = allmainelements[k6]['val'];
                        break;
                    }
                }
                if (packingsize != '' && packingsize.indexOf('*') >= 0) {
                    var packingsizearray = packingsize.split('*');
                    for (var k = 0; k < allmainelements.length; k++) {
                        if (allmainelements[k]['name'] == 'length' && packingsizearray.length > 0) {
                            allmainelements[k]['val'] = packingsizearray[0];
                        }
                        if (allmainelements[k]['name'] == 'width' && packingsizearray.length > 1) {
                            allmainelements[k]['val'] = packingsizearray[1];
                        }
                        if (allmainelements[k]['name'] == 'height' && packingsizearray.length > 2) {
                            allmainelements[k]['val'] = packingsizearray[2];
                        }
                    }
                }
            },
            productlengthBlur(allmainelements, allchildelements) {
                console.log('productlengthBlur...');
                console.log(allmainelements);
                console.log(allchildelements);
                var length = 0;
                var width = 0;
                var height = 0;
                for (var k6 = 0; k6 < allmainelements.length; k6++) {
                    if (allmainelements[k6]['name'] == 'length') {
                        length = Number(allmainelements[k6]['val']);
                    }
                    if (allmainelements[k6]['name'] == 'width') {
                        width = Number(allmainelements[k6]['val']);
                    }
                    if (allmainelements[k6]['name'] == 'height') {
                        height = Number(allmainelements[k6]['val']);
                    }
                }
                if (!isNaN(length) && !isNaN(width) && !isNaN(height) && length > 0 && width > 0 && height > 0) {
                    for (var k = 0; k < allmainelements.length; k++) {
                        if (allmainelements[k]['name'] == 'packingsize') {
                            allmainelements[k]['val'] = length + '*' + width + '*' + height;
                            break;
                        }
                    }
                }
            },
            costPricefunBlur(allmainelements, allchildelements) {
                console.log('costPricefunBlur...');
                console.log(allmainelements);
                console.log(allchildelements);
                var price = 0;
                var boxNumber = 0;
                var costprice = 0;
                for (var k6 = 0; k6 < allmainelements.length; k6++) {
                    if (allmainelements[k6]['name'] == 'price') {
                        price = Number(allmainelements[k6]['val']);
                    }
                    if (allmainelements[k6]['name'] == 'boxnumber') {
                        boxNumber = Number(allmainelements[k6]['val']);
                    }
                }
                if (!isNaN(boxNumber) && !isNaN(price)) {
                    costprice = parseFloat((price * boxNumber).toFixed(2));
                }
                for (var k = 0; k < allmainelements.length; k++) {
                    if (allmainelements[k]['name'] == 'costprice') {
                        allmainelements[k]['val'] = costprice;
                        break;
                    }
                }
            },
            dialogmsgClose() {
                MessageTip.onClose();
            },
            selfmaximize() {
                CommonJs.selfmaximize();
            },
            dialogClose() {
                this.butLoading = false;
            },
            showEditHistory() {
                if (this.editHistoryButTxt == '隐藏修改痕迹') {
                    this.$refs.universalpage.clearEditHistory();
                    this.editHistoryButTxt = '显示修改痕迹';
                    return;
                }
                this.$refs.universalpage.showEditHistory(this.seteditHistoryButTxt);
            },
            seteditHistoryButTxt() {
                this.editHistoryButTxt = '隐藏修改痕迹';
            }
        },
        components: {
            NewUniversalPage,
            FlowHistory,
            ConfirmPopup,
            'AppFooter': AppFooter,
            Image
        }
    }
</script>
<style lang="scss" scoped>
    .product-image {
        width: 50px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
    }

    .orders-subtable {
        padding: 1rem;
    }
</style>